import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "poll-voters-details__popover",
  tabindex: "0"
}
const _hoisted_2 = { class: "poll-voters-details__display-name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcPopover = _resolveComponent("NcPopover")

  return (_openBlock(), _createBlock(_component_NcPopover, {
    class: "poll-voters-details",
    trigger: "hover"
  }, {
    trigger: _withCtx(() => [
      _createVNode(_component_NcButton, {
        variant: "tertiary-no-background",
        "aria-label": $options.t('spreed', 'Voted participants'),
        class: "poll-voters-details__button"
      }, {
        icon: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.details.slice(0, 8), (item, index) => {
            return (_openBlock(), _createBlock(_component_AvatarWrapper, {
              id: item.actorId,
              key: index,
              token: $props.token,
              name: $options.getDisplayName(item),
              source: item.actorType,
              size: $setup.AVATAR.SIZE.EXTRA_SMALL,
              condensed: "",
              "disable-menu": "",
              "disable-tooltip": ""
            }, null, 8, ["id", "token", "name", "source", "size"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["aria-label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.details, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "poll-voters-details__list-item"
          }, [
            _createVNode(_component_AvatarWrapper, {
              id: item.actorId,
              token: $props.token,
              name: item.actorDisplayName.trim(),
              source: item.actorType,
              size: $setup.AVATAR.SIZE.EXTRA_SMALL,
              "disable-menu": ""
            }, null, 8, ["id", "token", "name", "source", "size"]),
            _createElementVNode("p", _hoisted_2, _toDisplayString($options.getDisplayName(item)), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}